import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from "../../components/LoadableLoading";
import {ILoadedProps, IProps} from "./interface";
import {isMobile} from 'react-device-detect';

export const path = `/event-type/list/`;

const getPage = () => {
    return isMobile ? import(`./page.mobile`) : import(`./page`);
};

const PageDefectTypeList: React.FC<IProps> = (props) => {
    const loader: any = {
        page: () => getPage(),
        i18n: () => import(`./ru.json`),
    };

    const LoadableMap = Loadable.Map({
        loader,
        loading: LoadableLoading,
        render(loaded: ILoadedProps, loadedProps): React.ReactNode {
            const Page: any = loaded.page.default;
            return (
                <Page {...loadedProps}
                      {...props}
                      i18n={{...loaded.i18n}}/>
            );
        }
    });

    return <LoadableMap {...props} />;
};

export default PageDefectTypeList;
